import axios from 'axios'

export type LeaderboardRank = {
    address: string
    fees: number
    n: number
    name: string
    points: number
    fee_points: number
    v1_nft_points: number
    ranking: number
    n_live: number
    pool_factor: number
    time_factor: number
}

export async function loadLeaderboardData(walletAddress: string, skip = 0, limit = 100): Promise<{ list: LeaderboardRank[]; user: LeaderboardRank | undefined; n: number }> {
    try {
        // const response = await axios.get(`https://clapi.myswap.xyz/cl/leaderboard?account=${'0x5e80f9d441b6823bfd2a829665cb02c863b9272152f24e35f72d1a8dbf75f8e'}&skip=${skip}&limit=${limit}`)
        const response = await axios.get(`https://clapi.myswap.xyz/cl/leaderboard?account=${walletAddress}&skip=${skip}&limit=${limit}`)
        // `https://clapi.myswap.xyz/cl/leaderboard?account=${'0x5e80f9d441b6823bfd2a829665cb02c863b9272152f24e35f72d1a8dbf75f8e'}&skip=${skip}&limit=${limit}`
        const data = response.data.data as { list: LeaderboardRank[]; user: LeaderboardRank | undefined; n: number }
        data.user = response.data.user
        return data
    } catch (e) {
        return { list: [], user: undefined, n: 0 }
    }
}
